import { render, staticRenderFns } from "./AtomVideo.vue?vue&type=template&id=8a35a4b0&"
import script from "./AtomVideo.vue?vue&type=script&lang=js&"
export * from "./AtomVideo.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports